import { Component, OnInit } from '@angular/core';
import { GalleryPageServiceService } from '../gallery-page/gallery-page-service.service';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';

declare var bootbox: any;
declare var $: any;


@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit {
  constructor(private GalleryPageService: GalleryPageServiceService) {}

 slides = [
    { image: "../../assets/img/home/SB/1.jpg", caption: 'Quality organizations,great people.' },
    { image: "../../assets/img/home/SB/2.jpg", caption: 'Recruiting top IT talent.' },
    { image: "../../assets/img/home/SB/3.jpg", caption: 'Professional Staffing.' },
    { image: "../../assets/img/home/SB/4.jpg", caption: 'We offer a wide range of staffing.' },
    { image: "../../assets/img/home/SB/5.jpg", caption: 'Quality Manpower anytime, anywhere.' },
    
  ];
  customerWhatsapp: string = '';
  name : string = '';
  userMessage: string = '';

  currentIndex = 0;
  images: any[] = [];

  ngOnInit() {
    this.startSlideshow();
    this.loadGallery();
  }

  startSlideshow() {
    setInterval(() => {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    }, 5000); // Change slide every 2 seconds
  }

  loadGallery(): void {
    this.GalleryPageService.getJobImage().subscribe(
      (data) => {
        this.images = data;
      },
      (error) => {
        console.error('Error loading gallery', error);
      }
    );
  }


formatWhatsappNumber() {
  if (!this.customerWhatsapp) return;

  this.customerWhatsapp = this.customerWhatsapp.replace(/\D/g, '');

  if (this.customerWhatsapp.length === 10) {
    this.customerWhatsapp = '91' + this.customerWhatsapp;
  }
}

getWhatsappLink(): string {

  const pdfUrl = 'https://yourdomain.com/invoice/sample.pdf';

  const message =
    `Hello ${this.name || ''},
    
Please find your PDF here:
${pdfUrl}

${this.userMessage}`;

  return `https://wa.me/${this.customerWhatsapp}?text=${encodeURIComponent(message)}`;
}

// generatePDF() {

//   const data = document.getElementById('pdfData');

//   html2canvas(data!).then((canvas: { height: number; width: number; toDataURL: (arg0: string) => any; }) => {

//     const imgWidth = 208;
//     const pageHeight = 295;

//     const imgHeight = canvas.height * imgWidth / canvas.width;

//     const contentDataURL = canvas.toDataURL('image/png');

//     const pdf = new jsPDF('p', 'mm', 'a4');

//     pdf.addImage(contentDataURL, 'PNG', 0, 0, imgWidth, imgHeight);

//     pdf.save('invoice.pdf');

//   });

// }


}

